import {
  Components,
  inputAdornmentClasses,
  inputBaseClasses,
  outlinedInputClasses,
  Theme,
} from '@mui/material';
import { Spacing6, Spacing2, Spacing3 } from '../spacing/index';
import { Content } from '../color';

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'medium',
  },
  styleOverrides: {
    root: {
      [`.${inputBaseClasses.inputSizeSmall}.${outlinedInputClasses.input}`]: {
        padding: `${Spacing2} ${Spacing3}`,
        height: `${Spacing6}`,
        [`&.${inputBaseClasses.inputMultiline}`]: {
          padding: `${Spacing2} ${Spacing3}`,
        },
      },
      [`&.${inputBaseClasses.root}`]: {
        padding: 0,
        [`.${inputAdornmentClasses.root}`]: {
          color: Content.main,
        },
      },
    },
  },
};
